'use client';
import React from 'react';
import { Star } from 'lucide-react';
import { useLanguage } from '@/context/LanguageContext';

const testimonials = [
  {
    id: 'test-001',
    name: 'Priya Sharma',
    role: 'Content Creator · 180K followers',
    avatar: 'PS',
    avatarColor: 'bg-primary/20 text-primary',
    quoteKey: 'quote1',
    stars: 5,
    tagKey: 'tag1',
  },
  {
    id: 'test-002',
    name: 'Marcus Webb',
    role: 'Small Business Owner · E-commerce',
    avatar: 'MW',
    avatarColor: 'bg-accent/20 text-accent',
    quoteKey: 'quote2',
    stars: 5,
    tagKey: 'tag2',
  },
  {
    id: 'test-003',
    name: 'Linda Okafor',
    role: 'Elementary School Teacher',
    avatar: 'LO',
    avatarColor: 'bg-mint/20 text-mint',
    quoteKey: 'quote3',
    stars: 5,
    tagKey: 'tag3',
  },
  {
    id: 'test-004',
    name: 'Diego Ramirez',
    role: 'Digital Marketing Manager',
    avatar: 'DR',
    avatarColor: 'bg-secondary-foreground/20 text-secondary-foreground',
    quoteKey: 'quote4',
    stars: 5,
    tagKey: 'tag4',
  },
];

export default function TestimonialsSection() {
  const { t } = useLanguage();
  const ts = t?.testimonialsSection;

  return (
    <section className="py-24 bg-background">
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-8 xl:px-10 2xl:px-16">
        <div className="text-center mb-14">
          <p className="text-xs font-600 uppercase tracking-widest text-mint mb-3">
            {ts?.sectionLabel ?? 'Creator Stories'}
          </p>
          <h2 className="text-hero-md font-700 text-foreground mb-4">
            {ts?.sectionTitle ?? 'Real People, Real Creations'}
          </h2>
          <p className="text-muted-foreground max-w-xl mx-auto text-base">
            {ts?.sectionSubtitle ?? 'From first-time creators to seasoned marketers — see what our community is building.'}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 2xl:grid-cols-4 gap-5">
          {testimonials?.map((item) => (
            <div key={item?.id} className="glass-card rounded-2xl p-6 flex flex-col gap-4">
              <div className="flex items-center gap-1">
                {Array.from({ length: item?.stars })?.map((_, i) => (
                  <Star key={`star-${item?.id}-${i}`} size={14} className="text-accent fill-accent" />
                ))}
              </div>
              <p className="text-sm text-foreground leading-relaxed flex-1">
                {ts?.[item.quoteKey as keyof typeof ts] ?? item.quoteKey}
              </p>
              <div className="flex items-center gap-3 pt-2 border-t border-border">
                <div className={`w-9 h-9 rounded-full ${item?.avatarColor} flex items-center justify-center text-xs font-700`}>
                  {item?.avatar}
                </div>
                <div>
                  <p className="text-sm font-600 text-foreground">{item?.name}</p>
                  <p className="text-xs text-muted-foreground">{item?.role}</p>
                </div>
              </div>
              <span className="text-[10px] font-600 px-2 py-0.5 rounded-full bg-primary/10 text-primary w-fit">
                {ts?.[item.tagKey as keyof typeof ts] ?? item.tagKey}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}